import { createClient, SanityClient } from '@sanity/client';
import { createImageUrlBuilder } from '@sanity/image-url';
import { SanityImage } from '../@types';
import { runtimeEnv } from '../config/runtimeEnv';

let sanityClient: SanityClient | null = null;

export const SANITY_API_VERSION = '2026-08-11';

export const initSanityClient = (projectId?: string, dataset?: string) => {
  const finalProjectId = runtimeEnv.sanityProjectId || projectId;
  const finalDataset = runtimeEnv.sanityDataset || dataset;

  if (!finalProjectId || !finalDataset) {
    return null;
  }

  sanityClient ??= createClient({
    projectId: finalProjectId,
    dataset: finalDataset,
    useCdn: true,
    apiVersion: SANITY_API_VERSION,
  });

  return sanityClient;
};

export const sanityImageURL = (image?: SanityImage, options?: { w?: number; h?: number }): string => {
  if (!image || !sanityClient) return '';

  const isSVG = image.asset?._ref?.endsWith('-svg') ?? false;

  let builder = createImageUrlBuilder(sanityClient).image(image);

  if (options?.w) builder = builder.width(options.w);
  if (options?.h) builder = builder.height(options.h);

  return isSVG ? builder.url() : builder.format('webp').url();
};

export const sanityVideoURL = (video?: SanityImage): string | null => {
  if (!video || !sanityClient) return null;

  const assetRef = video.asset?._ref;
  const assetRefMatch = assetRef?.match(/^file-([^-]+)-([a-z0-9]+)$/i);
  const { projectId, dataset } = sanityClient.config();

  if (!assetRefMatch || !projectId || !dataset) return null;

  const [, assetId, format] = assetRefMatch;
  const url = `https://cdn.sanity.io/files/${projectId}/${dataset}/${assetId}.${format}`;

  return url;
};
